import { MutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import { callGetApi, callPostApi } from './api-client';
import { User } from '../types/user';

export const userQuery = {
  queryKey: ['currentUser'],
  queryFn: () => callGetApi<User>('/enterprise/admin/auth_data/'),
  retry: 1,
};

export const useUserQuery = () => useQuery(userQuery);

export interface LoginCredentials {
  username: string;
  password: string;
}
export const useLoginMutation = (
  mutationOptions: MutationOptions<User, Error, LoginCredentials>
) =>
  useMutation({
    mutationFn: (credentials: LoginCredentials) =>
      callPostApi<User>('/enterprise/admin/login/', credentials),
    ...mutationOptions,
  });

export const useLogoutMutation = (
  mutationOptions?: MutationOptions<unknown, Error, void>
) =>
  useMutation({
    mutationFn: () => callPostApi('/enterprise/admin/logout/'),
    ...mutationOptions,
  });
